module.exports = __webpack_public_path__ + "img/image.00337a2a.png";